module.exports = "<div class=\"mastfoot\">\n  <div class=\"inner\">\n    <img src=\"assets/img/vortex_logo_white.svg\" alt=\"\">\n    <p class=\"copyright\">\n      Vortex Aquatic Structures International Inc. © All rights reserved. Site designed and developed by\n      <a target=\"_blank\" href=\"http://www.dynamaze.ca/\">Dynamaze</a>\n    </p>\n    <p class=\"pull-right\" style=\"font-size: 10px; line-height: 34px;\">v{{ version }}</p>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/components/footer/footer.html
// module id = ./src/app/main/components/footer/footer.html
// module chunks = main